/// <reference path="../../scripts/typings/i18next/i18next.d.ts" />
/// <reference path="../../scripts/typings/jquery/jquery.d.ts" />
define('services/simpleusermanager',["require", "exports", "durandal/app", "models/portal", "services/trace", "models/account", "services/httpclient", "common/string", "services/settings", "areas/account/viewmodels/login"], function (require, exports, App, Portal, Trace, Account, Http, Strings, Configuration, Login) {
    "use strict";
    var CODEFLOW = "authorizationcode";
    var AUTHORIZE_ENDPOINT = "/auth/core/connect/authorize";
    var SCOPE = "openid WK.UK.OneClick IdentityPersonalData";
    var SimpleUserManager = (function () {
        function SimpleUserManager() {
            this._flow = CODEFLOW;
            this._shell = Portal.Context.shell;
            this._taskManager = this._shell.taskManager;
            this._flow = Configuration.Settings.environment.userManager.flow || CODEFLOW;
            this._serverUrl = Configuration.Settings.environment.userManager.serverUrl + AUTHORIZE_ENDPOINT;
            this._redirectUrl = Configuration.Settings.getTokenExchangeEndpoint();
            this._postLogoutUrl = window.location.protocol + "//" + window.location.hostname + "/html";
            App.off("authentication", this.onAuthenticationChanged, this);
            App.on("authentication", this.onAuthenticationChanged, this);
        }
        SimpleUserManager.prototype.switchUserAccount = function () {
            var switcherurl = "";
            Account.Session.clear();
            var responseType = (this._flow === CODEFLOW) ? "code" : "id_token";
            var aaaConfigurationData = Configuration.Settings.environment.userManager.aaaConfiguration;
            this._clientId = aaaConfigurationData.isMFAEnabled ? 'WK.UK.OneClick.MFA' : 'WK.UK.OneClick';
            var state = jQuery.base64.encode(window.location.protocol + "//" + window.location.hostname + "/html" + ";" + this._redirectUrl + ";" + aaaConfigurationData.isMFAEnabled + ";" + aaaConfigurationData.practiceGuid);
            var nonce = Math.random().toString();
            var prompt = aaaConfigurationData.isSSOEnabled ? "prompt=login&" : "";
            var acrValues = aaaConfigurationData.isAAAEnabled ? "acr_values=" : "";
            acrValues += !aaaConfigurationData.isSSOEnabled ? "wkBranding:" + aaaConfigurationData.organizationalUnitId + " wkFilterByBrandingId:true" : "";
            acrValues += aaaConfigurationData.isSSOEnabled ? "idp:" + aaaConfigurationData.ssoIdentityProvider + " wkBranding:" + aaaConfigurationData.organizationalUnitId + " wkFilterByBrandingId:true wkContextManager:noCompanySession" : "";
            switcherurl = this._serverUrl + "?" +
                "client_id=" + encodeURI(this._clientId) + "&" +
                "redirect_uri=" + encodeURI(this._redirectUrl) + "&" +
                "nocompanysession" + "&" +
                "response_type=" + encodeURI(responseType) + "&" +
                "scope=" + encodeURI(SCOPE) + "&" +
                "state=" + state + "&" +
                "nonce=" + encodeURI(nonce) + "&" +
                prompt +
                acrValues;
            console.log("Simple UserManager switchUserAccount executed : " + switcherurl);
            window.location.assign(switcherurl);
        };
        SimpleUserManager.prototype.getSwitchUserAccountUrl = function () {
            throw new Error('Method not implemented.');
        };
        SimpleUserManager.prototype.showDialog = function () {
            var login = new Login();
            login.showClientNumber = false;
            var dialog = new Portal.ContentDialog();
            dialog.path = "areas/account/views/login";
            dialog.model = login;
            this._shell.showDialog(dialog);
        };
        SimpleUserManager.prototype.signIn = function (login) {
            return this.authenticate(login);
        };
        SimpleUserManager.prototype.signInFromNid = function (symbol) {
            var _this = this;
            return this._taskManager.startAsync("Benutzerdaten werden geprüft...", function () {
                return _this.authenticateFrom(symbol)
                    .then(function (data) {
                    App.trigger("authentication", true);
                })
                    .fail(function (reason) {
                    var message = "Direkte Anmeldung fehlgeschlagen: " + reason;
                    Trace.traceError(message, null, "Anmeldung", true);
                    _this.showDialog();
                });
            });
        };
        SimpleUserManager.prototype.signInFromSecret = function (symbol) {
            var _this = this;
            var secret = this.getStringValue(symbol, "secret");
            var application = this.getStringValue(symbol, "application") || "dWtjbGllbnRwb3J0YWwNCg==";
            var request = new Account.Requests.LoginRequest(null, "Secret:" + secret, application, null, false);
            return this._taskManager.startAsync("Benutzerdaten werden geprüft...", function () {
                return _this.authenticate(request)
                    .then(function (data) {
                    App.trigger("authentication", true);
                })
                    .fail(function (reason) {
                    var message = "Direkte Anmeldung fehlgeschlagen: " + reason;
                    Trace.traceError(message, null, "Anmeldung", true);
                    _this.showDialog();
                });
            });
        };
        SimpleUserManager.prototype.signInFromSessionId = function (symbol) {
            var _this = this;
            var sessionId = this.getStringValue(symbol, "session");
            var request = new Account.Requests.LoginRequest(null, "SessionId:" + sessionId, "null", null, false);
            // Convert jQueryPromise to Q.Promise
            return Q(this._taskManager.startAsync("Benutzerdaten werden geprüft...", function () {
                return _this.authenticate(request)
                    .then(function (data) {
                    App.trigger("authentication", true);
                    return data; // Returning data if needed
                })
                    .fail(function (reason) {
                    var message = "Direkte Anmeldung fehlgeschlagen: " + reason;
                    Trace.traceError(message, null, "Anmeldung", true);
                    _this.showDialog();
                    return $.Deferred().reject(reason).promise(); // Reject the promise with the reason
                });
            }));
        };
        SimpleUserManager.prototype.signInFromRefreshToken = function () {
            var _this = this;
            return this._taskManager.startAsync("Benutzerdaten werden geprüft...", function () {
                return _this.authenticateWithRefreshToken()
                    .then(function (data) {
                    App.trigger("authentication", true);
                })
                    .fail(function (reason) {
                    var message = "Automatische Anmeldung fehlgeschlagen: " + reason;
                    Trace.traceError(message, null, "Anmeldung", true);
                    _this.showDialog();
                });
            });
        };
        SimpleUserManager.prototype.signInFromSsoHash = function (hash) { throw new Error("Not implemented"); };
        SimpleUserManager.prototype.signInFromIdToken = function (hash) {
            throw new Error("Method not implemented.");
        };
        SimpleUserManager.prototype.signInFromAccessToken = function (hash) {
            throw new Error("Method not implemented.");
        };
        SimpleUserManager.prototype.signInFromAuthorizationCode = function (hash) {
            this.signOut();
            return Q(true);
        };
        SimpleUserManager.prototype.signOutSwitchUser = function () {
            var channel = new Http.Channel();
            channel.postDataAsync("/api/account/logout", Http.ServiceTarget.portalApi, null);
            // in jedem Fall
            Account.Session.clear();
            this._shell.router.navigate("#");
            App.trigger("authentication", true);
        };
        SimpleUserManager.prototype.getChangePasswordUrl = function () {
            throw new Error("Method not implemented.");
        };
        //signOut(): void {
        //    // send to server
        //    var channel = new Http.Channel();
        //    channel.postDataAsync("/api/account/logout", Http.ServiceTarget.portalApi, null);
        //    // in jedem Fall
        //    Account.Session.clear();
        //    // redirect
        //    this._shell.router = null;
        //    App.trigger("authentication", true);
        //    window.location.href = window.location.origin + "/html";
        //}
        SimpleUserManager.prototype.endSession = function () {
            // send to server
            var channel = new Http.Channel();
            channel.postDataAsync("/api/account/logout", Http.ServiceTarget.portalApi, null);
            // in jedem Fall
            Account.Session.clear();
        };
        SimpleUserManager.prototype.signOut = function () {
            this.endSession();
            var postLogoutUrl = this._postLogoutUrl + "/?logout=true";
            var aaaConfigurationData = Configuration.Settings.environment.userManager.aaaConfiguration;
            var clientId = aaaConfigurationData.isMFAEnabled ? 'WK.UK.OneClick.MFA' : 'WK.UK.OneClick';
            var url = Configuration.Settings.environment.getCustomValue("LogoutUrl") + "?clientid=" + clientId + "&redirecturl=" + encodeURI(postLogoutUrl);
            localStorage.removeItem('deepLink');
            window.location.assign(url);
        };
        SimpleUserManager.prototype.getSettings = function (key) {
            var that = this;
            var channel = new Http.Channel();
            var settingsUrl = "/api/Account/me/settings/" + key;
            return channel.getDataAsync(settingsUrl, Http.ServiceTarget.portalApi);
        };
        SimpleUserManager.prototype.saveSettings = function (key, settings) {
            var that = this;
            var channel = new Http.Channel();
            var settingsUrl = "/api/Account/me/settings/" + key;
            return channel.postDataAsync(settingsUrl, Http.ServiceTarget.portalApi, settings);
        };
        SimpleUserManager.prototype.changePassword = function (memberId, hash, password) {
            var channel = new Http.Channel();
            return channel.putDataAsync("/api/network/members/" + memberId + "/password/changerequests/" + hash, Http.ServiceTarget.publicApi, password);
        };
        SimpleUserManager.prototype.setPasswordFor = function (userId, memberId, password) {
            var channel = new Http.Channel();
            if (userId === null)
                return channel.putDataAsync("/api/network/members/" + memberId + "/password", Http.ServiceTarget.publicApi, password);
            else
                return channel.putDataAsync("/api/network/useridentities/" + userId + "/password", Http.ServiceTarget.publicApi, password);
        };
        SimpleUserManager.prototype.resetPassword = function (login) {
            var url = Configuration.Settings.environment.getCustomValue("ResetPasswordEndpoint");
            if (url) {
                return this.resetPasswordWithConfiguration(login, url);
            }
            else {
                return this.resetPasswordWithoutConfiguration(login);
            }
        };
        //#region event handling
        SimpleUserManager.prototype.onAuthenticationChanged = function () {
            this._shell.hideDialog();
        };
        //#endregion
        //#region helpers
        SimpleUserManager.prototype.getPrincipal = function () {
            var that = this;
            var channel = new Http.Channel();
            var currentSystemLanguage = i18n.lng();
            return channel.getData("/api/Account/Principal", Http.ServiceTarget.portalApi)
                .then(function (result) {
                var principal = Account.Principal.from(result, currentSystemLanguage);
                if (Strings.contains(Account.Principal.current.memberType, "_gateway")) {
                    that.signOut();
                    throw "Dieser Benutzer dient dem Datenaustausch mit externen Systemen, eine direkte Anmeldung ist mit ihm nicht möglich.";
                }
                return principal;
            })
                .fail(function (reason) {
                Trace.traceError("Fehler bei der Anmeldung: " + reason, null, "Anmeldung", true);
                return $.Deferred().reject(reason).promise();
            });
        };
        SimpleUserManager.prototype.authenticate = function (login) {
            var _this = this;
            var currentSystemLanguage = i18n.lng();
            var defer = Q.defer();
            var data = login.toJson();
            this.sendOAuthRequest(data, login.authenticationHeader)
                .then(function (data) {
                Account.Session.clear();
                Account.Session.setAuthentication(data.access_token, data.expires_in);
                if (login.keepSignedIn) {
                    Account.Session.refreshToken = data.refresh_token;
                }
                // Handle the asynchronous `getPrincipal` method
                return Q(_this.getPrincipal()); // Convert the JQueryPromise to Q.Promise
            })
                .then(function (principal) {
                Account.Principal.current = principal;
                Account.Session.loginName = principal.loginName;
                defer.resolve(principal); // Resolve with the retrieved principal
            })
                .fail(function (reason) {
                defer.reject(_this.readAuthenticationError(reason)); // Reject with the error reason
            });
            return defer.promise;
        };
        SimpleUserManager.prototype.authenticateWithRefreshToken = function () {
            var _this = this;
            var defer = Q.defer();
            var data = {
                grant_type: "refresh_token",
                refresh_token: Account.Session.refreshToken
            };
            this.sendOAuthRequest(data, Account.Requests.PortalBasicAuthenticationHeader)
                .then(function (data) {
                Account.Session.clear();
                Account.Session.setAuthentication(data.access_token, data.expires_in);
                Account.Session.refreshToken = data.refresh_token;
                // Handle the asynchronous `getPrincipal` method
                return Q(_this.getPrincipal()); // Convert the JQueryPromise to Q.Promise
            })
                .then(function (principal) {
                Account.Principal.current = principal;
                Account.Session.loginName = principal.loginName;
                defer.resolve(principal); // Resolve with the retrieved principal
            })
                .fail(function (reason) {
                defer.reject(_this.readAuthenticationError(reason)); // Reject with the error reason
            });
            return defer.promise;
        };
        SimpleUserManager.prototype.authenticateFrom = function (symbol) {
            var _this = this;
            var defer = Q.defer();
            var channel = new Http.Channel();
            channel.postDataAsync("/api/account/login", Http.ServiceTarget.portalApi, symbol)
                .then(function (data) {
                Account.Session.clear();
                Account.Session.setAuthentication(data.access_token, data.expires_in);
                // Handle the asynchronous `getPrincipal` method
                return Q(_this.getPrincipal()); // Convert the JQueryPromise to Q.Promise
            })
                .then(function (principal) {
                Account.Principal.current = principal;
                Account.Session.loginName = principal.loginName;
                defer.resolve(principal); // Resolve with the retrieved principal
            })
                .fail(function (reason) {
                defer.reject(_this.readAuthenticationError(reason)); // Reject with the error reason
            });
            return defer.promise;
        };
        SimpleUserManager.prototype.resetPasswordWithConfiguration = function (login, url) {
            url = url.replace('{0}', login.domain);
            url += "/api/password/resetpassword";
            var data = {
                userName: login.username
            };
            var response = $.ajax({
                url: url,
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify(data),
                crossDomain: true,
                async: true,
                beforeSend: function (req) {
                    if (Account.Session.isAuthenticated) {
                        req.setRequestHeader("Authorization", Account.Session.getAuthorizationHeader());
                    }
                }
            });
            return Q(response);
        };
        SimpleUserManager.prototype.resetPasswordWithoutConfiguration = function (login) {
            var channel = new Http.Channel();
            var parameters = "&domain=" + login.domain + "&clientNumber=" + login.clientNumber + "&username=" + login.username;
            return channel.postDataAsync("/api/password/resetpassword" + "?" + parameters, Http.ServiceTarget.portalApi, null);
        };
        SimpleUserManager.prototype.sendOAuthRequest = function (data, authHeader) {
            var endpoint = "connect/token";
            var service = "authority";
            var tokenServer = Configuration.Settings.getServiceFor(service, endpoint, null);
            return Q(jQuery.ajax(tokenServer, {
                type: "POST",
                async: false,
                beforeSend: function (xhr, settings) {
                    xhr.setRequestHeader("Authorization", authHeader);
                },
                contentType: "application/x-www-form-urlencoded",
                //mimeType: "application/json",
                data: data
            }));
        };
        SimpleUserManager.prototype.readAuthenticationError = function (reason) {
            try {
                if (typeof (reason) == "string")
                    return reason;
                var message = JSON.parse(reason.responseText);
                var result = message.error;
                var detail = message.error_description;
                if (result === "invalid_grant") {
                    result = $.t("app:modules.account.message_loginError", { ifMissing: "Es ist ein Fehler bei der Anmeldung aufgetreten. Bitte prüfen Sie Ihre Zugangsdaten." });
                    if (detail.indexOf(5002) > 0) {
                        result = $.t("app:modules.account.message_memberDisabled", { ifMissing: "Der Zugang wurde gesperrt!" });
                    }
                }
                return result;
            }
            catch (exception) {
                return JSON.stringify(reason);
            }
        };
        SimpleUserManager.prototype.getStringValue = function (url, field) {
            var href = url ? url : window.location.href;
            var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
            var string = reg.exec(href);
            return string ? string[1] : null;
        };
        ;
        return SimpleUserManager;
    }());
    return SimpleUserManager;
});

